// Pure digit-only buffer logic for NumericInput (POS amount-pad style). Kept framework-free so it
// is unit-testable without a DOM/render library. A "buffer" is a string of digits filled from the
// right; `decimals` controls the implied decimal point (2 → money/percent "0.00"; 0 → integer).

export const digitsOnly = (s) => String(s == null ? "" : s).replace(/\D/g, "");

export function bufToNum(buf, decimals) {
  const d = digitsOnly(buf);
  if (!d) return 0;
  return decimals > 0 ? Number(d) / Math.pow(10, decimals) : Number(d);
}

export function numToBuf(n, decimals) {
  const v = Math.max(0, Number(n) || 0);
  const scaled = decimals > 0 ? Math.round(v * Math.pow(10, decimals)) : Math.round(v);
  return scaled ? String(scaled) : "";
}

/**
 * Apply one keystroke to the buffer. `key` is a single digit "0".."9", "DEL" (backspace) or "C"
 * (clear); anything else is ignored. Strips leading zeros, clamps to `max`, caps length.
 * @returns {{ buf: string, value: number }}
 */
export function applyDigitKey(buf, key, { decimals = 2, max } = {}) {
  const cur = String(buf || "");
  let next;
  if (/^[0-9]$/.test(key)) next = cur + key;
  else if (key === "DEL") next = cur.slice(0, -1);
  else if (key === "C") next = "";
  else return { buf: cur, value: bufToNum(cur, decimals) };

  let d = digitsOnly(next).replace(/^0+(?=\d)/, "").slice(0, 12);
  let value = bufToNum(d, decimals);
  if (max != null && value > Number(max)) {
    value = Number(max);
    d = numToBuf(value, decimals);
  }
  return { buf: d, value };
}
